import React from 'react';

export const NotFound = () => {
    return (
        <div className="container">
            Not found
        </div>
    )
}